import { Capacitor } from '@capacitor/core'
import { PushNotifications, type Token, type ActionPerformed } from '@capacitor/push-notifications'
import client from '@/api/client'
import { storage } from '@/api/preferences'

let registeredHandlers = false

export async function registerPush(onTap?: (data: Record<string, any>) => void): Promise<void> {
  if (!Capacitor.isNativePlatform()) return

  const result = await PushNotifications.requestPermissions()
  if (result.receive !== 'granted') return

  if (!registeredHandlers) {
    PushNotifications.addListener('registration', async (token: Token) => {
      await client.post('/me/push-tokens', {
        platform: Capacitor.getPlatform(),
        token: token.value,
      })
      await storage.set('pavemi_last_push_token', token.value)
    })
    PushNotifications.addListener('registrationError', (err) => {
      console.error('Push registration error', err)
    })
    PushNotifications.addListener('pushNotificationActionPerformed', (action: ActionPerformed) => {
      if (onTap) onTap(action.notification.data || {})
    })
    registeredHandlers = true
  }

  await PushNotifications.register()
}

export async function unregisterPush(token?: string): Promise<void> {
  if (!token || !Capacitor.isNativePlatform()) return
  await client.delete(`/me/push-tokens/${encodeURIComponent(token)}`)
}
